<template>
  <div :data-test="`compliance-next-review-${index}`">
    <WdsText v-if="nextReview" :error="isOverdue" :text="formatReviewDate(nextReview)" />
    <WdsText v-else secondary sm :text="$t('—')" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import {
  complianceDate,
  formatReviewDate,
  VerifiedComplianceDateKey,
} from '@/components/GraphqlDataTable/columns/Compliance/verifiedComplianceData'

const ComplianceNextReviewColumn = graphql(`
  fragment ComplianceNextReviewColumn on TrustedContact {
    id
    verifiedCompliance: compliances(names: [VERIFIED_WORKER_COMPLIANCE], cached: true) {
      name
      data {
        ...VerifiedComplianceDate
      }
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof ComplianceNextReviewColumn>
  index: number
}>()

const column = computed(() => useFragment(ComplianceNextReviewColumn, props.row))

const nextReview = computed(() =>
  complianceDate(
    column.value.verifiedCompliance?.[0]?.data,
    VerifiedComplianceDateKey.NextReviewAt,
  ),
)
const isOverdue = computed(
  () => nextReview.value !== null && Date.parse(nextReview.value) < Date.now(),
)
</script>
